var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArticleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2889_77808)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.375 17.1234H7.49833C7.95818 17.1234 8.41352 17.2139 8.83836 17.3899C9.2632 17.5659 9.64923 17.8238 9.97439 18.149C10.2995 18.4741 10.5575 18.8601 10.7335 19.285C10.9094 19.7098 11 20.1652 11 20.625H1.375V17.1234Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5017 17.1234H20.625V20.625H11C11 19.6963 11.3689 18.8057 12.0256 18.149C12.6823 17.4923 13.573 17.1234 14.5017 17.1234Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.375 5.7475H7.49833C7.95818 5.7475 8.41352 5.83807 8.83836 6.01405C9.2632 6.19002 9.64923 6.44795 9.97439 6.77311C10.2995 7.09827 10.5575 7.48429 10.7335 7.90913C10.9094 8.33398 11 8.78932 11 9.24916V20.625H1.375V5.7475Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0033 5.7475H20.625V20.625H11V9.24916C11 8.32046 11.3689 7.4298 12.0256 6.77311C12.6823 6.11642 13.573 5.7475 14.5017 5.7475",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0017 11.9167L16.2509 13.6675L14.5 11.9167V3.12586C14.4988 2.8956 14.5433 2.66738 14.6308 2.45441C14.7184 2.24144 14.8473 2.04794 15.0101 1.88512C15.1729 1.7223 15.3664 1.59338 15.5794 1.50582C15.7924 1.41827 16.0206 1.37381 16.2509 1.37502C16.7152 1.37502 17.1605 1.55949 17.4889 1.88783C17.8172 2.21618 18.0017 2.66151 18.0017 3.12586V11.9167Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2889_77808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIcon);
export default __webpack_public_path__ + "static/media/articleIcon.c4ec06c37fea886388d035222ba800fa.svg";
export { ForwardRef as ReactComponent };